import { useState } from "react";

import { FooterSocialLinks } from "#/components/FooterSocialLinks";

import { FooterLegalNav } from "./FooterLegalNav";

export default function Footer() {
  const [year] = useState(() => new Date().getFullYear());

  return (
    <footer className="shrink-0 grow-0 border-t border-border bg-background px-4 py-4 text-muted-foreground sm:py-6">
      <div className="mx-auto grid w-full max-w-5xl grid-cols-1 gap-2 p-3 text-sm sm:grid-cols-[1fr_auto_1fr] sm:items-center">
        <span className="text-center sm:text-left">&copy; {year} Daily Wars</span>
        <div className="flex justify-center">
          <FooterSocialLinks />
        </div>
        <FooterLegalNav />
      </div>
    </footer>
  );
}
